var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_1423)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87478 30.1252 1.66667 20 1.66667C9.87478 1.66667 1.66667 9.87478 1.66667 20C1.66667 30.1252 9.87478 38.3333 20 38.3333ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2036 22.0648C12.5875 21.4487 11.9714 20.8326 11.4786 20.2166C10.8625 19.3541 9.63037 18.4916 11.3554 17.3827C11.8482 17.013 11.4786 16.2737 11.3554 15.7809C10.9857 14.672 10.8625 13.5631 10.8625 11.8381C12.4643 14.1791 14.066 15.5345 16.4071 16.1505C17.1464 16.397 17.8857 16.3969 18.7482 16.5202C20.2267 16.6434 20.8428 15.9041 20.966 14.4255C21.3356 10.6059 23.4303 9.37377 26.757 11.3452C27.9892 12.0845 28.482 10.9755 29.4677 10.8523C29.8374 11.838 30.4534 12.8237 29.4677 13.9327C28.9749 14.4255 29.0981 15.1648 29.0981 15.9041C28.9749 21.6951 25.4017 26.5004 19.8571 28.2254C18.1321 28.8415 16.2839 29.2111 14.3125 29.2111C12.7107 29.0879 11.2321 28.8415 10 27.2397C11.6018 26.9933 13.45 27.8558 14.5589 26.0076C13.8196 24.8987 11.8482 24.529 11.725 22.6808C11.9714 22.0648 12.8339 22.6808 13.2036 22.0648Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_1423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.c5c677f606a88a2495c1b76e535c259a.svg";
export { ForwardRef as ReactComponent };